(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('sm-collection-faqs')) {

    customElements.define(
      'sm-collection-faqs',
      class extends HTMLElement {

        connectedCallback() {

          if (this.faqSearchHandler) return;

          this.faqSearchHandler = (event) => {

            if (!event.target.matches('[data-faq-search]')) return;

            const query = event.target.value
              .trim()
              .toLocaleLowerCase();

            let visible = 0;

            this.querySelectorAll('[data-faq-item]').forEach((row) => {

              const match = row.textContent
                .toLocaleLowerCase()
                .includes(query);

              row.hidden = !match;

              if (match) visible += 1;

            });

            const message =
              this.querySelector('[data-faq-no-results]');

            if (message) {
              message.hidden = visible !== 0;
            }

          };

          this.addEventListener(
            'input',
            this.faqSearchHandler
          );

        }


        disconnectedCallback() {

          this.removeEventListener(
            'input',
            this.faqSearchHandler
          );

          this.faqSearchHandler = null;

        }

      }
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-image-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-hotspot-gallery')) {
    customElements.define('sm-hotspot-gallery', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected || this.events) return;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.cards = Array.from(this.querySelectorAll('.smhg__card'));
        this.popups = Array.from(this.querySelectorAll('.smhg__popup'));
        this.nativePopover = 'showPopover' in HTMLElement.prototype;
        this.masonry = this.dataset.layout === 'masonry' && 'ResizeObserver' in window;
        if (this.masonry) this.setAttribute('data-masonry-ready', '');
        else {
          this.removeAttribute('data-masonry-ready');
          this.cards.forEach(card => card.style.removeProperty('grid-row-end'));
        }
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.layout();
            if (this.activePopup) this.positionPopup(this.activePopup);
          });
        };
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.schedule);
          this.cards.forEach(card => this.observer.observe(card.querySelector('.smhg__card-body')));
          this.popups.forEach(popup => this.observer.observe(popup));
        }
        window.addEventListener('resize', this.schedule, { signal });
        window.addEventListener('scroll', this.schedule, { signal, passive: true, capture: true });
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', this.schedule, { signal });
          window.visualViewport.addEventListener('scroll', this.schedule, { signal, passive: true });
        }
        this.addEventListener('load', this.schedule, { signal, capture: true });

        this.popups.forEach(popup => {
          popup.addEventListener('toggle', event => {
            const open = event.newState === 'open';
            const trigger = this.triggerFor(popup);
            if (trigger) trigger.setAttribute('aria-expanded', String(open));
            if (open) {
              this.activePopup = popup;
              this.positionPopup(popup);
            } else if (this.activePopup === popup) {
              this.activePopup = null;
            }
          }, { signal });
        });

        this.addEventListener('click', event => {
          const spot = event.target.closest('.smhg__spot');
          const close = event.target.closest('.smhg__close');
          if (close) {
            event.preventDefault();
            const popup = close.closest('.smhg__popup');
            this.closePopup(popup);
            this.triggerFor(popup)?.focus({ preventScroll: true });
            return;
          }
          if (!spot) return;
          event.preventDefault();
          const popup = this.popups.find(item => item.id === spot.getAttribute('popovertarget'));
          if (!popup) return;
          if (this.activePopup === popup) {
            this.closePopup(popup);
            return;
          }
          document.querySelectorAll('sm-hotspot-gallery').forEach(gallery => {
            if (gallery.activePopup) gallery.closePopup(gallery.activePopup);
          });
          this.activePopup = popup;
          if (this.nativePopover) popup.showPopover();
          else popup.setAttribute('data-fallback-open', '');
          spot.setAttribute('aria-expanded', 'true');
          this.positionPopup(popup);
          popup.querySelector('.smhg__close')?.focus({ preventScroll: true });
        }, { signal });

        document.addEventListener('pointerdown', event => {
          if (!this.activePopup || this.nativePopover) return;
          const trigger = this.triggerFor(this.activePopup);
          if (!this.activePopup.contains(event.target) && !trigger?.contains(event.target)) this.closePopup(this.activePopup);
        }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !this.activePopup) return;
          event.preventDefault();
          const trigger = this.triggerFor(this.activePopup);
          this.closePopup(this.activePopup);
          trigger?.focus({ preventScroll: true });
        }, { signal });

        // Keep the selected marker visible while editing its coordinates.
        // Opening its popup here would hide the object being positioned.
        this.addEventListener('shopify:block:select', event => {
          const spot = Array.from(this.querySelectorAll('.smhg__spot')).find(item => item.dataset.hotspotId === event.detail.blockId);
          if (spot) {
            spot.setAttribute('data-editor-selected', '');
            spot.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
          this.schedule();
        }, { signal });
        this.addEventListener('shopify:block:deselect', event => {
          const spot = Array.from(this.querySelectorAll('.smhg__spot')).find(item => item.dataset.hotspotId === event.detail.blockId);
          spot?.removeAttribute('data-editor-selected');
        }, { signal });
        this.layout();
      }

      layout() {
        if (!this.masonry) return;
        this.cards.forEach(card => {
          const height = card.querySelector('.smhg__card-body').getBoundingClientRect().height;
          const span = 'span ' + Math.max(1, Math.ceil(height));
          if (card.style.gridRowEnd !== span) card.style.gridRowEnd = span;
        });
      }

      triggerFor(popup) {
        return Array.from(this.querySelectorAll('.smhg__spot')).find(spot => spot.getAttribute('popovertarget') === popup.id);
      }

      closePopup(popup) {
        if (!popup) return;
        if (this.nativePopover) {
          if (popup.matches(':popover-open')) popup.hidePopover();
        } else popup.removeAttribute('data-fallback-open');
        this.triggerFor(popup)?.setAttribute('aria-expanded', 'false');
        if (this.activePopup === popup) this.activePopup = null;
      }

      positionPopup(popup) {
        const trigger = this.triggerFor(popup);
        if (!trigger || !this.isConnected) return;
        const viewport = window.visualViewport;
        const width = viewport ? viewport.width : document.documentElement.clientWidth;
        const height = viewport ? viewport.height : window.innerHeight;
        const originX = viewport ? viewport.offsetLeft : 0;
        const originY = viewport ? viewport.offsetTop : 0;
        const inset = 16;
        const box = trigger.getBoundingClientRect();
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        popup.style.maxWidth = Math.max(1, width - inset * 2) + 'px';
        popup.style.maxHeight = Math.max(1, mobile ? Math.min(height * .7, 560) : height - inset * 2) + 'px';
        const panel = popup.getBoundingClientRect();
        let left;
        let top;
        if (mobile) {
          left = originX + (width - panel.width) / 2;
          top = originY + height - inset - panel.height;
        } else {
          left = box.left + box.width / 2 - panel.width / 2;
          top = box.bottom + 10;
          if (top + panel.height > originY + height - inset) top = box.top - panel.height - 10;
          left = Math.min(Math.max(left, originX + inset), originX + width - panel.width - inset);
          top = Math.min(Math.max(top, originY + inset), originY + height - panel.height - inset);
        }
        popup.style.left = left + 'px';
        popup.style.top = top + 'px';
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.observer?.disconnect();
        this.events?.abort();
        this.events = null;
        if (this.activePopup) this.closePopup(this.activePopup);
        this.removeAttribute('data-masonry-ready');
        this.cards?.forEach(card => card.style.removeProperty('grid-row-end'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slatwall-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-slatwall-calculator')) {
    customElements.define('sm-slatwall-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.q = selector => this.querySelector(selector);
        this.options = Array.from(this.querySelectorAll('[data-option]')).map(el => ({
          el, radio: el.querySelector('input[type="radio"]'),
          data: JSON.parse(el.querySelector('[data-panel-data]').textContent)
        }));
        this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
          style: 'currency', currency: this.dataset.currency || 'NZD'
        }).format(value / 100);
        this.decimal = value => new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(value);
        this.options.forEach(option => {
          const prices = option.data.variants.map(v => v.price);
          option.el.querySelector('[data-card-price]').textContent = prices.length
            ? (Math.min(...prices) !== Math.max(...prices) ? 'From ' : '') + this.money(Math.min(...prices)) + ' / pack'
            : 'Product unavailable';
        });
        let initial = this.options[0];
        if (this.dataset.autoSelect === 'true' && this.dataset.currentProduct) {
          initial = this.options.find(o => String(o.data.productId) === this.dataset.currentProduct) || initial;
        }
        this.q('form').addEventListener('submit', event => this.addToCart(event));
        this.addEventListener('change', event => {
          if (event.target.matches('.sm-sc__radio')) this.select(this.options.find(o => o.radio === event.target));
          else if (event.target.matches('[data-variant], [data-extra]')) this.update();
        });
        this.addEventListener('input', event => {
          if (event.target.matches('[data-length], [data-width]')) this.update();
        });
        if (initial) this.select(initial);
        else this.q('[data-status]').textContent = 'No panel options are currently available.';
      }
      select(option) {
        this.current = option.data;
        option.radio.checked = true;
        const select = this.q('[data-variant]');
        select.replaceChildren();
        this.current.variants.forEach(variant => {
          const item = document.createElement('option');
          item.value = variant.id;
          item.textContent = variant.title + (variant.available ? '' : ' — Sold out');
          select.appendChild(item);
        });
        select.value = String(this.current.preferredVariant || this.current.variants[0]?.id || '');
        this.q('[data-variant-wrap]').hidden = this.current.variants.length < 2;
        const link = this.q('[data-product-link]');
        link.hidden = !this.current.url;
        link.href = this.current.url || '#';
        this.update();
      }
      update() {
        if (!this.current || this.busy) return;
        const set = (key, value) => { this.q('[data-' + key + ']').textContent = value; };
        const button = this.q('[data-add]');
        const lengthInput = this.q('[data-length]'), widthInput = this.q('[data-width]');
        const length = lengthInput.valueAsNumber, width = widthInput.valueAsNumber;
        const panel = this.current;
        const variant = panel.variants.find(v => String(v.id) === this.q('[data-variant]').value);
        const extra = Number(this.q('[data-extra]').value);
        this.order = null;
        button.disabled = true;
        this.q('[data-variant-id]').value = '';
        this.q('[data-quantity]').value = '';
        set('status', '');
        this.q('[data-estimate]').hidden = true;
        this.q('[data-prompt]').hidden = false;
        set('prompt', 'Enter your wall width and height to get started.');
        button.textContent = 'Enter dimensions above';
        if (!(length > 0 && width > 0 && lengthInput.validity.valid && widthInput.validity.valid)) return;
        if (!(panel.length > 0 && panel.width > 0 && Number.isInteger(panel.pack) && panel.pack > 0)) {
          set('prompt', 'Please contact us to calculate this panel option.');
          return;
        }
        const up = value => Math.max(1, Math.ceil(value - 1e-9));
        const rows = up(width * 1000 / panel.width);
        const base = up(rows * length * 1000 / panel.length);
        const withoutReuse = rows * up(length * 1000 / panel.length);
        const needed = up(base * (1 + extra / 100));
        let packs = up(needed / panel.pack);
        if (variant) {
          const min = Math.max(1, Number(variant.min) || 1), increment = Math.max(1, Number(variant.increment) || 1);
          packs = Math.ceil(Math.max(packs, min) / increment) * increment;
        }
        if (!Number.isSafeInteger(packs) || !Number.isSafeInteger(packs * panel.pack)) {
          set('prompt', 'Please contact us for an estimate for this area.');
          return;
        }
        this.q('[data-estimate]').hidden = false;
        this.q('[data-prompt]').hidden = true;
        set('packs', packs.toLocaleString());
        set('pack-label', packs === 1 ? 'pack' : 'packs');
        set('product-name', panel.title);
        set('area', this.decimal(length * width) + ' m²');
        set('grid', rows.toLocaleString() + ' horizontal rows');
        set('base', base.toLocaleString());
        set('saved', (withoutReuse - base).toLocaleString());
        set('needed', needed.toLocaleString());
        set('supplied', (packs * panel.pack).toLocaleString());
        set('coverage', this.decimal(packs * panel.pack * panel.length * panel.width / 1000000) + ' m²');
        set('total', variant ? this.money(packs * variant.price) : 'Unavailable');
        if (!variant || !variant.available || panel.requiresPlan) {
          button.textContent = variant && !variant.available ? 'Currently sold out' : 'View product for availability';
          return;
        }
        if (variant.max > 0 && packs > variant.max) {
          button.textContent = 'Contact us for this quantity';
          set('status', 'This quantity exceeds the online purchase limit.');
          return;
        }
        this.order = { id: variant.id, quantity: packs };
        this.q('[data-variant-id]').value = variant.id;
        this.q('[data-quantity]').value = packs;
        button.textContent = 'Add ' + packs.toLocaleString() + (packs === 1 ? ' pack' : ' packs') + ' to cart';
        button.disabled = false;
      }
      async addToCart(event) {
        event.preventDefault();
        if (this.busy || !this.order || !this.q('form').reportValidity()) return;
        const order = { ...this.order };
        this.busy = true;
        this.q('.sm-sc__controls').disabled = true;
        this.q('[data-add]').textContent = 'Adding to cart…';
        this.q('[data-status]').textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [order] })
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : 'The requested quantity could not be added.');
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.busy = false;
          this.q('.sm-sc__controls').disabled = false;
          this.update();
          this.q('[data-status]').textContent = (error.message || 'We could not confirm the cart update.') + ' Please check your cart before trying again.';
          this.q('[data-cart-link]').hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
